var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.classes},[(_vm.title !== null)?_c('div',{staticClass:"py-1 text-lg font-bold leading-loose uppercase"},[_vm._t("title",function(){return [_vm._v("\n                "+_vm._s(_vm.title)+"\n            ")]})],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }